var storageCache = {};

var hasLocalStorage = false;
var storage = {};

try {
  storage = window.localStorage;

  var x = '__storage_test__';
  storage.setItem(x, x);
  storage.removeItem(x);

  hasLocalStorage = true;
} catch (e) {
  // not available
}

export default {
  name: 'localStorage',

  // can be used globally and locally
  global: true,
  local: true,

  // reducerObjects is an object with the following structure:
  // { key: { reducer, value, type, options } }
  mutateReducerObjects: function mutateReducerObjects(input, output, reducerObjects) {
    if (hasLocalStorage && input.path) {
      Object.keys(reducerObjects).filter(function (key) {
        return reducerObjects[key].options && reducerObjects[key].options.persist;
      }).forEach(function (key) {
        var path = output.path.join('.') + '.' + key;
        var defaultValue = reducerObjects[key].value;
        var defaultReducer = reducerObjects[key].reducer;

        var value = storage[path] ? JSON.parse(storage[path]) : defaultValue;
        storageCache[path] = value;

        var reducer = function reducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : value;
          var payload = arguments[1];

          var result = defaultReducer(state, payload);
          if (storageCache[path] !== result) {
            storageCache[path] = result;
            storage[path] = JSON.stringify(result);
          }
          return result;
        };

        reducerObjects[key].reducer = reducer;
        reducerObjects[key].value = value;
      });
    }
  },
  clearCache: function clearCache() {
    storageCache = {};
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/kea-localstorage/es/index.js
// module id = 210
// module chunks = 0